jQuery(document).ready(function($) {
    const drone = $('.drone');
    const audio = drone.next();
    let droneWingsInterval;
    let droneFrame = 1;
    let holdingAlt = false;

    function startDrone() {
        audio[0].onplay = () => {
            droneWingsInterval = setInterval(() => {
                droneFrame++;
                if (droneFrame === 4) {
                    droneFrame = 1;
                }
                drone.attr('data-frame', droneFrame);
            }, 100);

            drone.addClass('playing');
        };
        audio[0].onended = stopDrone;
        audio[0].play();
    }



    $(window).keydown(function(e) {
        holdingAlt = e.keyCode === 18;
    }).keyup(function(e) {
        if (e.keyCode === 18) {
            holdingAlt = false;
        }
    });


    $('.sidebar .image-wrapper').click(() => {
        if (!holdingAlt) {
            return;
        }
        stopDrone();
        startDrone();
    });

    function stopDrone() {
        clearInterval(droneWingsInterval);
        drone.removeClass('playing');
    }
});